import { render, staticRenderFns } from "./MarketplaceCellComponent.vue?vue&type=template&id=0f8a6b66"
import script from "./MarketplaceCellComponent.vue?vue&type=script&lang=js"
export * from "./MarketplaceCellComponent.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceCellComponent.vue?vue&type=style&index=0&id=0f8a6b66&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports